<template>
  <div class="item h-100">
    <slot :data="{ ...item, borderRadius }"></slot>
    <figure
      class="vx-grid-figure"
      :class="{ 'placeholder-shimmer': !loadedImage }"
      :style="{
        borderRadius: borderRadius + 'px'
      }"
    >
      <picture>
        <source :srcset="`${item.image}?fmt=webp&h=250`" type="image/webp" />
        <source :srcset="item.image" :type="item.isSvg ? 'image/png' : 'image/jpeg'" />
        <img
          class="vx-grid-thumb"
          :src="item.image"
          :alt="item.name || item.title"
          :width="item.width"
          :height="item.height"
          :style="{
            borderRadius: borderRadius + 'px'
          }"
          :loading="lazy ? 'lazy' : 'eager'"
          @load="removePlaceholder"
        />
      </picture>
      <figcaption class="vx-grid-figcaption">
        {{ item.name }}
      </figcaption>
    </figure>
    <slot name="bottomBar" :data="{ ...item, borderRadius }"></slot>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    borderRadius: {
      type: Number,
      required: false,
      default: 4
    },
    lazy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadedImage: false
    };
  },
  methods: {
    removePlaceholder() {
      this.loadedImage = true;
    }
  }
};
</script>

<style lang="scss" scoped>
figure {
  margin: 0;
}
.vx-grid-figure {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  background-color: $backgroundGray;
  border-radius: 7px !important;
}
.vx-grid-thumb {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  transition: opacity 0.3s ease;
  pointer-events: none;
}
.vx-grid-figcaption {
  display: none;
}

.placeholder-shimmer {
  overflow: hidden;
}
.placeholder-shimmer picture {
  position: relative;
  z-index: 1;
}
.placeholder-shimmer:after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 0;
  background: linear-gradient(90deg, #ffffff00, #dbdbdb75, #ffffff00);
  animation: b-skeleton-animate-wave 1s linear infinite;
}

@keyframes b-skeleton-animate-wave {
  0% {
    transform: translateX(-100%);
  }

  to {
    transform: translateX(100%);
  }
}
</style>
